<ng-template #templateRef>
    <mat-dialog-content>
        <h2 mat-dialog-title>Pick your articles
            <span class="text-right">
            <button mat-icon-button (click)="showFilters = !showFilters" type="button" id="showFilter">
                <mat-icon>filter_list</mat-icon>
            </button>
            </span>
        </h2>
        <mat-card appearance="outlined" style="margin-bottom: 50px;" [hidden]="!showFilters">
            <form #filterForm="ngForm" name="filterForm" (ngSubmit)="filter(filterForm.value)">
                <mat-card-title class="filter-title">Filter</mat-card-title>
                <mat-card-content>
                    <div class="row">
                        <div class="col-md-3">
                            <mat-form-field>
                              <mat-label>Art. code</mat-label>
                                <input matInput name="Code" ngModel>
                            </mat-form-field>
                        </div>
                        <div class="col-md-3">
                            <app-dropdown-option ngModel [getOnlyId]="true" multiple placeholder="Category" name="Category"
                                                 model="ArticleCategory" discriminator="Category"></app-dropdown-option>
                        </div>
                        <div class="col-md-3">
                            <mat-form-field>
                              <mat-label>Art. description</mat-label>
                                <input matInput name="Description" ngModel>
                            </mat-form-field>
                        </div>
                        <div class="col-md-3">
                            <mat-form-field>
                              <mat-label>Barcode</mat-label>
                                <input matInput name="Barcode" ngModel>
                            </mat-form-field>
                        </div>
                    </div>
                </mat-card-content>
              <mat-card-actions>
                <div style="margin: auto">
                  <button mat-button>Filter results</button>
                  <button mat-button (click)="showFilters = false">Close</button>
                </div>
              </mat-card-actions>
            </form>
        </mat-card>
        <form #editorForm="ngForm" name="editRelation" id="articleEditor">
            <mat-tab-group>
                <mat-tab label="Search results">
                    <div class="row">
                        <table class="mat-mdc-table">
                            <tr>
                                <td>
                                    <mat-checkbox (change)="onToggleAll($event)"></mat-checkbox>
                                </td>
                                <td>Commercial Name</td>
                                <td>Code</td>
                            </tr>
                            <tr *ngFor="let article of Articles">
                                <td>
                                    <mat-checkbox [checked]="isSelected(article)" (change)="onToggle($event, article)"></mat-checkbox>
                                </td>
                                <td>
                                  {{article.CommercialName}}
                                </td>
                                <td>
                                    {{article.Code}}
                                </td>
                            </tr>
                        </table>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <mat-paginator [length]="filterObject.count" [pageSize]="filterObject.limit"
                                           [pageSizeOptions]="[5, 10, 25, 100]" (page)="pageChange($event);"></mat-paginator>
                        </div>
                    </div>
                </mat-tab>
                <mat-tab label="Selected ({{Selected.length}})">
                    <table class="mat-mdc-table">
                        <tr>
                            <td>Commercial Name</td>
                            <td>Code</td>
                            <td>Barcode</td>
                        </tr>
                        <tr *ngFor="let article of Selected">
                          <td>
                            {{article.CommercialName}}
                          </td>
                            <td>
                                {{article.Code}}
                            </td>
                            <td>
                                {{article.Barcode}}
                            </td>
                        </tr>
                    </table>
                </mat-tab>
            </mat-tab-group>
        </form>
    </mat-dialog-content>
  <mat-dialog-actions>
    <div class="fill-remaining-space"></div>
    <button type="button" mat-button mat-raised-button mat-dialog-close>Close</button>
    <app-button [disabled]="!editorForm.form.valid" [isLoading]="isLoading" (onClick)="save()"></app-button>
  </mat-dialog-actions>
</ng-template>
